module.exports = __webpack_public_path__ + "img/fig13.f9e437d4.jpg";